import * as React from 'react';
import PrCelebration, { type PrItem } from './PrCelebration';

// Top-level host so a rep-max PR celebration can show after a workout is finished,
// even though the Started Training view unmounts on completion. Listens for the
// `workout:prs` event dispatched by finishWorkout.
export default function PrCelebrationHost() {
  const [prs, setPrs] = React.useState<PrItem[] | null>(null);

  React.useEffect(() => {
    const onPrs = (e: Event) => {
      const detail = (e as CustomEvent).detail;
      if (Array.isArray(detail) && detail.length) setPrs(detail as PrItem[]);
    };
    window.addEventListener('workout:prs', onPrs as EventListener);
    return () => window.removeEventListener('workout:prs', onPrs as EventListener);
  }, []);

  if (!prs) return null;
  return <PrCelebration prs={prs} onClose={() => setPrs(null)} />;
}
